// Tipos de recibo (mismos ids que Backend/app/Constants/PayslipType.php)
export const PAYSLIP_TYPE_BIWEEKLY = "biweekly";

export const PAYSLIP_TYPES = [
  { id: "monthly", name: "Mensual" },
  { id: PAYSLIP_TYPE_BIWEEKLY, name: "Quincenal" },
  { id: "sac", name: "SAC" },
  { id: "vacation", name: "Vacaciones" },
  { id: "final_settlement", name: "Liquidación final" },
  { id: "adjustment", name: "Ajuste" },
];

// Estados del recibo
export const PAYSLIP_STATUS_DRAFT = "draft";
export const PAYSLIP_STATUS_PUBLISHED = "published";
export const PAYSLIP_STATUS_VIEWED = "viewed";
export const PAYSLIP_STATUS_SIGNED = "signed";
export const PAYSLIP_STATUS_VOIDED = "voided";

export const PAYSLIP_STATUSES = {
  [PAYSLIP_STATUS_DRAFT]: { name: "Borrador", color: "grey lighten-3", text_color: "grey darken-3" },
  [PAYSLIP_STATUS_PUBLISHED]: { name: "Publicado", color: "blue lighten-4", text_color: "blue darken-3" },
  [PAYSLIP_STATUS_VIEWED]: { name: "Visto", color: "cyan lighten-4", text_color: "cyan darken-4" },
  [PAYSLIP_STATUS_SIGNED]: { name: "Firmado", color: "green lighten-4", text_color: "green darken-3" },
  [PAYSLIP_STATUS_VOIDED]: { name: "Anulado", color: "red lighten-4", text_color: "red darken-3" },
};

// Borrador con publicacion programada (chip y filtro)
export const PAYSLIP_FILTER_SCHEDULED = "scheduled";
export const PAYSLIP_SCHEDULED_CHIP = { name: "Programado", color: "purple lighten-4", text_color: "purple darken-3" };

export const PAYSLIP_EVENTS = {
  uploaded: "Carga",
  assigned: "Asignación de legajo",
  ai_read: "Lectura con IA",
  scheduled: "Publicación programada",
  schedule_cancelled: "Programación cancelada",
  published: "Publicación",
  notified: "Aviso por email enviado",
  downloaded: "Descarga",
  viewed: "Lectura del empleado",
  signed: "Firma del empleado",
  voided: "Anulación",
};

// Firma del empleado
export const CONFORMITY_AGREE = "agree";
export const CONFORMITY_DISAGREE = "disagree";

export const CONFORMITIES = {
  [CONFORMITY_AGREE]: { name: "Conforme", color: "green lighten-4", text_color: "green darken-3" },
  [CONFORMITY_DISAGREE]: { name: "Disconforme", color: "orange lighten-4", text_color: "orange darken-4" },
};

// Estado del recibo para el empleado (el firmado se muestra con su conformidad)
export const EMPLOYEE_STATUSES = {
  published: { name: "Nuevo · Pendiente de firma", color: "blue lighten-4", text_color: "blue darken-3" },
  viewed: { name: "Pendiente de firma", color: "orange lighten-4", text_color: "orange darken-4" },
};

// Chip del recibo firmado: "Firmado · Conforme" / "Firmado · Disconforme"
export function signedChip(item) {
  const conformity = CONFORMITIES[item.conformity];
  if (!conformity) return PAYSLIP_STATUSES[PAYSLIP_STATUS_SIGNED];
  return { name: "Firmado · " + conformity.name, color: conformity.color, text_color: conformity.text_color };
}

// Aviso por email al empleado
export const EMAIL_STATUSES = {
  pending: { name: "Email pendiente de envío", icon: "mdi-email-fast-outline", color: "grey" },
  sent: { name: "Email enviado", icon: "mdi-email-check-outline", color: "green" },
  failed: { name: "No se pudo enviar el email", icon: "mdi-email-alert-outline", color: "red" },
  no_email: { name: "El legajo no tiene email", icon: "mdi-email-off-outline", color: "orange" },
};

export const MONTHS = [
  { id: 1, name: "Enero" },
  { id: 2, name: "Febrero" },
  { id: 3, name: "Marzo" },
  { id: 4, name: "Abril" },
  { id: 5, name: "Mayo" },
  { id: 6, name: "Junio" },
  { id: 7, name: "Julio" },
  { id: 8, name: "Agosto" },
  { id: 9, name: "Septiembre" },
  { id: 10, name: "Octubre" },
  { id: 11, name: "Noviembre" },
  { id: 12, name: "Diciembre" },
];

export const BIWEEKLY_NUMBERS = [
  { id: 1, name: "1ra quincena" },
  { id: 2, name: "2da quincena" },
];

// "03/2026" o "03/2026 - 1ra quincena"
export function periodLabel(item) {
  let label = String(item.period_month).padStart(2, "0") + "/" + item.period_year;
  if (item.period_number != null) {
    const number = BIWEEKLY_NUMBERS.find((n) => n.id == item.period_number);
    if (number) label += " - " + number.name;
  }
  return label;
}

// Años para los filtros y la carga: del actual hacia atras
export function yearOptions(count = 6) {
  const current = new Date().getFullYear();
  return Array.from({ length: count }, (_, i) => current - i);
}

// "2026-03-05" -> "05/03/2026"
export function formatDate(date) {
  if (!date) return "-";
  const [year, month, day] = date.substr(0, 10).split("-");
  return `${day}/${month}/${year}`;
}

// "2026-03-05 14:20:00" -> "05/03/2026 14:20"
export function formatDateTime(date) {
  if (!date) return "-";
  return formatDate(date) + " " + date.substr(11, 5);
}

// "Marzo 2026" o "1ra quincena · Marzo 2026"
export function periodTitle(item) {
  const month = MONTHS.find((m) => m.id == item.period_month);
  let title = (month ? month.name : item.period_month) + " " + item.period_year;
  if (item.period_number != null) {
    const number = BIWEEKLY_NUMBERS.find((n) => n.id == item.period_number);
    if (number) title = number.name + " · " + title;
  }
  return title;
}

// Iniciales para el avatar del legajo
export function legajoInitials(legajo) {
  if (!legajo) return "?";
  return ((legajo.surname || "").charAt(0) + (legajo.name || "").charAt(0)).toUpperCase();
}

export function legajoLabel(legajo) {
  if (!legajo) return "-";
  return legajo.nro_legajo + " - " + legajo.surname + ", " + legajo.name;
}

// Filtro del buscador de los listados de recibos: nombre, nro de legajo o CUIL (leido o del legajo)
export function filterPayslips(items, search) {
  const q = (search || "").trim().toLowerCase();
  if (!q) return items;
  const digits = q.replace(/\D/g, "");
  return items.filter((p) => {
    if (p.legajo && (p.legajo.surname + " " + p.legajo.name + " " + p.legajo.name + " " + p.legajo.surname).toLowerCase().includes(q)) return true;
    if (!digits) return false;
    const cuils = [p.extracted_cuil || "", p.legajo ? p.legajo.cuil || "" : ""].map((c) => c.replace(/\D/g, ""));
    return (p.legajo && String(p.legajo.nro_legajo) == digits) || cuils.some((c) => c.includes(digits));
  });
}
